module.exports = __webpack_public_path__ + "img/default.06044f5f.png";